export const constructTaskFilterUrl = (
  projectId: number,
  queryString: string,
): string => `/projects/${projectId}/tasks/list${queryString}`;
